import { ApplicationConfig, importProvidersFrom, mergeApplicationConfig } from '@angular/core';
import { commonAppConfig } from '@ui/layout/common-app/common-app.config';
import { AppRoutingModule } from './app-routing.module';
import { AgentsState } from './state/agents.state';
import { FundsTransfersState } from './state/funds-transfers.state';


export const appConfig: ApplicationConfig = mergeApplicationConfig(commonAppConfig, {
    providers: [
        importProvidersFrom(AppRoutingModule),
        AgentsState,
        FundsTransfersState,
    ],
});
